import React from 'react';
import { Box } from '@mui/material';
import { AnimatePresence, motion, useReducedMotion } from 'motion/react';
import { useLocation, useOutlet } from 'react-router-dom';
import { SuiteShell } from '../components/layout/SuiteShell';

const privateContentMotion = {
  hidden: {
    opacity: 0,
    y: 12,
    filter: 'blur(2px)',
  },
  visible: {
    opacity: 1,
    y: 0,
    filter: 'blur(0px)',
    transition: {
      duration: 0.22,
      ease: [0.22, 1, 0.36, 1],
    },
  },
  exit: {
    opacity: 0,
    y: -8,
    filter: 'blur(1px)',
    transition: {
      duration: 0.16,
      ease: 'easeIn',
    },
  },
};

export const PrivateLayout = () => {
  const location = useLocation();
  const outlet = useOutlet();
  const reduceMotion = useReducedMotion();

  return (
    <SuiteShell>
      <AnimatePresence mode="wait" initial={false}>
        <Box
          component={motion.div}
          key={location.pathname}
          initial={reduceMotion ? false : 'hidden'}
          animate={reduceMotion ? undefined : 'visible'}
          exit={reduceMotion ? undefined : 'exit'}
          variants={reduceMotion ? undefined : privateContentMotion}
          sx={{ width: '100%' }}
        >
          {outlet}
        </Box>
      </AnimatePresence>
    </SuiteShell>
  );
};
